import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { ContextProvider } from "context/AuthenticationContext";
import "./assets/styles/global.scss";

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <Router>
    <ContextProvider>
      <App />
    </ContextProvider>
  </Router>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
